export default __webpack_public_path__ + "static/media/background.210fc5ea.png";